import TopBar from '@/components/feature/TopBar';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import FAQSection from '@/pages/home/components/FAQSection';
import { siteConfig } from '@/mocks/data';

export default function FAQPage() {
  const whatsappHref = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent('Merhaba, sık sorulan sorular sayfanızdan ulaşıyorum. Bilgi almak istiyorum.')}`;

  return (
    <div className="min-h-screen bg-background-50">
      <TopBar />
      <Navbar />
      <main>
        <section className="py-16 md:py-20 bg-secondary-800">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
            <h1 className="font-heading text-2xl md:text-5xl text-background-50 mb-4">Sık Sorulan Sorular</h1>
            <p className="text-background-50/70 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
              Fineco Isı Pompası ve hizmetlerimiz hakkında en çok merak edilen soruları sizin için yanıtladık.
            </p>
          </div>
        </section>
        <FAQSection />
        <section className="py-16 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-4">Aklınıza Takılan Başka Bir Şey Var mı?</h2>
            <p className="text-foreground-600 text-sm max-w-xl mx-auto mb-6">Sorunuzu WhatsApp üzerinden bize iletebilir, en kısa sürede yanıt alabilirsiniz.</p>
            <a href={whatsappHref} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[#25D366] text-white px-6 py-3 rounded-md text-sm font-semibold hover:bg-[#1faa51] transition-colors whitespace-nowrap">
              <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center"></i>
              WhatsApp'tan Sorun
            </a>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}